import toast from 'react-hot-toast';
import { waApi } from './waApi';

export interface UploadResult {
  url: string;
  key: string;
  filename: string;
  size: number;
  mime_type: string;
}

/**
 * Faz upload de midia (imagens, audios, documentos) para o S3
 * via backend WhatsApp (ContaChat).
 *
 * Organiza no bucket em: whatsapp/{conversationId}/{YYYY-MM}/{uuid}_{filename}
 *
 * Se o endpoint ainda nao existir no backend, faz fallback para blob local.
 */
export async function uploadWhatsAppMedia(
  file: File,
  conversationId: string,
): Promise<UploadResult | null> {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('conversation_id', conversationId);

  try {
    const res = await waApi.post<UploadResult>('/media/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 60000,
    });
    return res.data;
  } catch (err: any) {
    const status = err?.response?.status;

    // 404 = endpoint ainda nao criado no backend
    if (status === 404) {
      // eslint-disable-next-line no-console
      console.warn('[waUpload] Endpoint /media/upload nao encontrado. Usando blob local.');
      return null;
    }

    const detail = err?.response?.data?.detail;
    toast.error(detail || 'Erro ao fazer upload do arquivo');
    return null;
  }
}

/**
 * Converte um Blob (ex: gravacao de audio) em File para upload.
 */
export function blobToFile(blob: Blob, filename: string): File {
  return new File([blob], filename, { type: blob.type, lastModified: Date.now() });
}
